import React, { useState } from "react";
import theme from "@/constants/theme";
import { CustomCalendar } from "@/components/calendar/CustomCalendar";
import RecordsTabContent from "@/components/calendar/RecordsTabContent";

export default function CalendarPage() {
  const [activeTab, setActiveTab] = useState<"calendar" | "records">(
    "calendar"
  );

  return (
    <div style={styles.container}>
      {/* Tabs */}
      <div style={styles.tabBar}>
        <button
          style={{
            ...styles.tabButton,
            ...(activeTab === "calendar" ? styles.tabButtonActive : {}),
          }}
          onClick={() => setActiveTab("calendar")}
        >
          <p
            style={{
              ...styles.tabButtonText,
              ...(activeTab === "calendar" ? styles.tabButtonTextActive : {}),
            }}
          >
            Calendario
          </p>
        </button>

        <button
          style={{
            ...styles.tabButton,
            ...(activeTab === "records" ? styles.tabButtonActive : {}),
          }}
          onClick={() => setActiveTab("records")}
        >
          <p
            style={{
              ...styles.tabButtonText,
              ...(activeTab === "records" ? styles.tabButtonTextActive : {}),
            }}
          >
            Todos los Registros
          </p>
        </button>
      </div>

      {/* Content */}
      {activeTab === "calendar" ? <CustomCalendar /> : <RecordsTabContent />}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.colors.background.primary,
    padding: "16px",
  },
  tabBar: {
    display: "flex",
    flexDirection: "row" as const,
    margin: "16px 0",
  },
  tabButton: {
    flex: 1,
    alignItems: "center",
    padding: "8px 0",
    border: "initial",
    borderBottom: "2px solid transparent",
    backgroundColor: "transparent",
    cursor: "pointer",
  },
  tabButtonActive: {
    borderBottomColor: theme.colors.primary,
  },
  tabButtonText: {
    fontSize: "16px",
    color: "#999",
    margin: 0,
  },
  tabButtonTextActive: {
    color: "#fff",
    fontWeight: "bold",
  },
  tabContent: {
    paddingBottom: "24px",
  },
};
